import PropTypes from 'prop-types';
import React from 'react';
import { Spacer, Table } from 'src/core/components';

import { RowsSelected } from './components';

const ProductsTableComponent = ({
  id,
  data,
  config,
  onConfigChange = () => {},
  totalItems,
  onPaginationChange,
  setPagination,
  pagination,
  selectedProductsIds,
  category,
  subcategory,
  onDelete,
}) => (
  <>
    <RowsSelected
      selectedProductsIds={selectedProductsIds}
      category={category}
      subcategory={subcategory}
      onDelete={onDelete}
    />
    <Spacer top={15} />
    <Table
      {...{
        id,
        data,
        config,
        onConfigChange,
        totalItems,
        onPaginationChange,
        setPagination,
        pagination,
      }}
    />
  </>
);

ProductsTableComponent.propTypes = {
  id: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  subcategory: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  config: PropTypes.array.isRequired,
  onConfigChange: PropTypes.func,
  totalItems: PropTypes.number.isRequired,
  onPaginationChange: PropTypes.func.isRequired,
  setPagination: PropTypes.func.isRequired,
  pagination: PropTypes.object,
  selectedProductsIds: PropTypes.array.isRequired,
  isViewAllActive: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
};

export default ProductsTableComponent;
